<p-table
	#dt
	styleClass="p-datatable-responsive-demo"
	[value]="printerDeviceList"
	[loading]="!printerDeviceList"
	[globalFilterFields]="app.keys(printerDeviceList)"
	[scrollable]="true"
>
	<ng-template pTemplate="caption">
		<div class="table-header d-flex">
			<div class="flex-grow-1">
				<span class="p-float-label p-input-icon-left m-2 w-100">
					<i class="pi pi-search"></i>
					<input
						pInputText
						class="w-100"
						id="globalSearch"
						name="globalSearch"
						style="width: 100%"
						type="text"
						(input)="dt.filterGlobal($event.target.value, 'contains')"
					/>
					<label for="globalSearch">Search...</label>
				</span>
			</div>
			<p-button pRipple styleClass="p-button-raised p-button-primary m-2" (click)="newPrinterDeviceItem()">
				<ng-template pTemplate="content">
					<div class="d-flex justify-content-center">
						<fa-icon [icon]="['far', 'plus']" size="lg" class="ms-1 me-2"></fa-icon>
						Add Printer
					</div>
				</ng-template>
			</p-button>
		</div>
	</ng-template>
	<ng-template pTemplate="header">
		<tr>
			<th>Printer Name</th>
			<th>POS Printer ID</th>
			<th>Controlling Station</th>
		</tr>
	</ng-template>
	<ng-template let-rec pTemplate="body">
		<tr (click)="printerDeviceSelected = rec">
			<td>{{ rec.name }}</td>
			<td>
				{{ rec.posId }}
			</td>
			<td>
				{{ rec.controllingPosDeviceName }}
			</td>
		</tr>
	</ng-template>
</p-table>

<app-printer-device-setup
	*ngIf="printerDeviceSelected"
	[posStationList]="posStationList"
	[(printerDeviceSelected)]="printerDeviceSelected"
></app-printer-device-setup>
